module.exports = __webpack_public_path__ + "img/MG_4644-scaled.acbd2903.jpg";